import { gql } from "@apollo/client";

export default gql`
  mutation GetInviteToken($targetType: String!, $targetId: String!) {
    getInviteToken(targetType: $targetType, targetId: $targetId)
  }
`;
